// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1c85n","formContainer":"Y4QLu","flexWrapper":"Lwcb4","leftCol":"_3wp1V","rightCol":"_2c5Hc","rightOuter":"AAXuJ","footer":"_3yQoM"};